(function() {
  const customHTML = `
    <div id="custom-recharge-proxy" class="is-loading">
      <div class="ffm-rc-skeleton" aria-hidden="true">
        <div class="ffm-rc-skeleton__card ffm-rc-skeleton__card--sub"></div>
        <div class="ffm-rc-skeleton__card"></div>
      </div>

      <div class="custom-card custom-sub-card selected" id="proxy-sub-option">
        <div class="custom-badge" id="proxy-badge"></div>

        <div class="custom-header">
          <div class="custom-radio-group">
            <div class="custom-radio-outer">
                <div class="custom-radio-inner"></div>
            </div>
            <span class="custom-title" id="proxy-sub-title">Subscription Member</span>
          </div>
          <div class="custom-price-group">
            <span class="custom-old-price" id="proxy-sub-old-price"></span>
            <span class="custom-new-price" id="proxy-sub-new-price"></span>
          </div>
        </div>

        <div class="custom-separator"></div>

        <div class="custom-details">
            <ul class="custom-benefits" id="proxy-benefits-list"></ul>

            <div class="custom-frequency">
              <label id="proxy-frequency-label" for="proxy-frequency-select">Deliver every:</label>
              <select id="proxy-frequency-select" class="custom-select" aria-labelledby="proxy-frequency-label">
                <option>Loading...</option>
              </select>
            </div>
        </div>
      </div>

      <div class="custom-card custom-onetime-card" id="proxy-onetime-option">
        <div class="custom-header" style="width:100%; padding:0;">
            <div class="custom-radio-group">
              <div class="custom-radio-outer">
                <div class="custom-radio-inner"></div>
              </div>
              <span class="custom-title" id="proxy-otp-title">One-time purchase</span>
            </div>
            <span class="custom-new-price" id="proxy-otp-price"></span>
        </div>
      </div>
    </div>
  `;

  const findDeep = (root, selector) => {
    let found = root.querySelector(selector);
    if (found) return found;
    const allElements = root.querySelectorAll('*');
    for (let el of allElements) {
      if (el.shadowRoot) {
        found = findDeep(el.shadowRoot, selector);
        if (found) return found;
      }
    }
    return null;
  };

  const getText = (el) => {
    if (!el) return '';
    return (el.innerText || el.textContent || '').trim();
  };

  const parsePriceAmount = (text) => {
    const cleaned = (text || '')
      .replace(/Original price.*|Discounted price.*/gi, '')
      .replace(/,/g, '')
      .trim();
    const amount = parseFloat(cleaned.replace(/[^0-9.]/g, ''));
    return Number.isFinite(amount) && amount > 0 ? amount : null;
  };

  /** Match PDP prices ($66.59) — Recharge may emit US$ after combined-listing swaps. */
  const formatPriceAmount = (dollars) => {
    if (dollars == null) return '';
    const cents = Math.round(dollars * 100);
    const format = window.globalSpace?.money_format;
    if (typeof Utility !== 'undefined' && Utility.formatMoney) {
      return Utility.formatMoney(cents, format);
    }
    return '$' + dollars.toFixed(2);
  };

  const getCurrentVariant = () => {
    const params = new URLSearchParams(window.location.search);
    const urlVariant = params.get('variant');
    if (urlVariant) return urlVariant;
    const formInput = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    return formInput?.value || '';
  };

  const notifyRechargeVariantChange = () => {
    const input = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    if (!input) return;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('variant:change', {
      bubbles: true,
      detail: { variantId: input.value }
    }));
  };

  const clickRealElement = (widget, el) => {
    if (!el) return;

    const saved = widget.style.cssText;
    widget.style.pointerEvents = 'auto';

    if (el.type === 'radio' || el.type === 'checkbox') {
      el.checked = true;
    }

    el.dispatchEvent(new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      composed: true,
      view: window
    }));
    el.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    el.dispatchEvent(new Event('input', { bubbles: true, composed: true }));

    setTimeout(() => {
      widget.style.cssText = saved;
    }, 100);
  };

  let activeController = null;
  let widgetWatchInterval = null;

  function destroyProxyWidget() {
    if (activeController) {
      activeController.destroy();
      activeController = null;
    }
    document.getElementById('custom-recharge-proxy')?.remove();
  }

  function initProxyWidget() {
    const realWidget = document.querySelector('recharge-subscription-widget') || document.querySelector('rc-widget');
    if (!realWidget || !realWidget.shadowRoot) return false;
    if (document.getElementById('custom-recharge-proxy')) return true;

    realWidget.insertAdjacentHTML('beforebegin', customHTML);

    const proxyRoot = document.getElementById('custom-recharge-proxy');
    const elements = {
      subTitle: document.getElementById('proxy-sub-title'),
      subOldPrice: document.getElementById('proxy-sub-old-price'),
      subNewPrice: document.getElementById('proxy-sub-new-price'),
      badge: document.getElementById('proxy-badge'),
      benefitsList: document.getElementById('proxy-benefits-list'),
      otpTitle: document.getElementById('proxy-otp-title'),
      otpPrice: document.getElementById('proxy-otp-price'),
      select: document.getElementById('proxy-frequency-select'),
      subCard: document.getElementById('proxy-sub-option'),
      otpCard: document.getElementById('proxy-onetime-option')
    };

    const shadow = realWidget.shadowRoot;
    let pricesSet = false;
    let otpVisibilitySet = false;
    let badgeVisibilitySet = false;
    let lastVariant = getCurrentVariant();
    let frequencyBound = false;
    let lastBenefitsKey = '';
    let proxyReady = false;
    let pricesSetAt = 0;

    const hideRealWidget = () => {
      realWidget.style.cssText = `
        position: absolute !important;
        left: -9999px !important;
        top: 0 !important;
        opacity: 0 !important;
        pointer-events: none !important;
        z-index: -1 !important;
      `;
    };

    // Keep Recharge rendered for data access, but remove it from the page layout.
    hideRealWidget();

    const markProxyLoading = () => {
      proxyReady = false;
      pricesSetAt = 0;
      proxyRoot?.classList.add('is-loading');
      proxyRoot?.classList.remove('is-ready');
    };

    const isFrequencyReady = () => {
      if (!elements.select || elements.select.options.length === 0) return false;
      const first = (elements.select.options[0].textContent || '').trim();
      return first !== '' && !/^loading/i.test(first);
    };

    const tryMarkProxyReady = () => {
      if (proxyReady || !pricesSet) return;

      const realSelect = findDeep(shadow, 'select');
      // Wait for Recharge's options, with a fallback for alternate widget layouts.
      if (realSelect && !isFrequencyReady()) {
        if (!pricesSetAt || Date.now() - pricesSetAt < 2500) return;
      }

      proxyReady = true;
      proxyRoot?.classList.remove('is-loading');
      proxyRoot?.classList.add('is-ready');
    };

    const resetOnVariantChange = () => {
      pricesSet = false;
      otpVisibilitySet = false;
      badgeVisibilitySet = false;
      lastBenefitsKey = '';
      markProxyLoading();
      elements.subOldPrice.innerText = '';
      elements.subNewPrice.innerText = '';
      elements.otpPrice.innerText = '';
      elements.badge.innerText = '';
      if (elements.benefitsList) elements.benefitsList.innerHTML = '';
      elements.select.innerHTML = '<option>Loading...</option>';
      frequencyBound = false;
      elements.subCard.classList.add('selected');
      elements.otpCard.classList.remove('selected');
      elements.otpCard.style.display = '';
      const radioOuter = elements.subCard.querySelector('.custom-radio-outer');
      if (radioOuter) radioOuter.style.display = '';
      elements.subCard.style.cursor = '';
      elements.subCard.style.width = '';
      elements.subCard.style.maxWidth = '';
      const proxy = document.getElementById('custom-recharge-proxy');
      if (proxy) {
        proxy.style.width = '';
        proxy.style.maxWidth = '';
      }
    };

    const syncFrequencySelect = (realSelect) => {
      if (!realSelect || realSelect.options.length === 0) return;
      const nextHtml = realSelect.innerHTML;
      if (elements.select.innerHTML !== nextHtml) {
        elements.select.innerHTML = nextHtml;
        frequencyBound = false;
      }
      elements.select.value = realSelect.value;
      if (!frequencyBound) {
        frequencyBound = true;
        elements.select.addEventListener('change', (e) => {
          realSelect.value = e.target.value;
          realSelect.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    };

    /**
     * Benefits live in nested shadow DOM:
     * recharge-subscription-widget → rc-benefits → [part=rc-benefits__list]
     */
    const getRechargeBenefitsHost = () =>
      shadow.querySelector('rc-benefits#rc-benefits')
      || shadow.querySelector('rc-benefits')
      || findDeep(shadow, 'rc-benefits');

    const readBenefitsTexts = () => {
      const benefitsHost = getRechargeBenefitsHost();
      if (!benefitsHost?.shadowRoot) return [];

      const benefitsShadow = benefitsHost.shadowRoot;
      const listEl = benefitsShadow.querySelector('[part~="rc-benefits__list"]')
        || benefitsShadow.querySelector('[part="rc-benefits__list"]')
        || benefitsShadow.querySelector('.rc-benefits__list');
      const items = listEl
        ? listEl.querySelectorAll('li')
        : benefitsShadow.querySelectorAll('li');
      // innerText is empty while Recharge keeps its source widget off-screen.
      const read = (el) => (el?.textContent || '').replace(/\s+/g, ' ').trim();

      let texts = Array.from(items)
        .map((li) => read(li.querySelector('p') || li))
        .filter(Boolean);

      if (!texts.length && listEl) {
        texts = Array.from(listEl.querySelectorAll('p'))
          .map((p) => read(p))
          .filter(Boolean);
      }

      return texts;
    };

    const syncBenefitsList = () => {
      if (!elements.benefitsList) return;

      const texts = readBenefitsTexts();
      if (!texts.length) return;

      const nextKey = texts.join('\n');
      if (nextKey === lastBenefitsKey) return;
      lastBenefitsKey = nextKey;

      elements.benefitsList.innerHTML = '';
      texts.forEach((text) => {
        const li = document.createElement('li');
        li.textContent = text;
        elements.benefitsList.appendChild(li);
      });
    };

    const ensureSubscriptionSelected = () => {
      const subInput = findDeep(shadow, 'input[value="subscription"]');
      if (subInput && !subInput.checked) {
        clickRealElement(realWidget, subInput);
      }
    };

    const syncContent = () => {
      const currentVariant = getCurrentVariant();
      if (currentVariant !== lastVariant) {
        lastVariant = currentVariant;
        resetOnVariantChange();
      }

      const subTitleEl = findDeep(shadow, '.rc-purchase-option__subscription .rc-purchase-option__text');
      if (subTitleEl) elements.subTitle.innerText = subTitleEl.childNodes[0].textContent.trim();

      if (!otpVisibilitySet) {
        const otpEl = findDeep(shadow, '.rc-selection__onetime') || findDeep(shadow, 'input[value="onetime"]');
        if (otpEl !== null || findDeep(shadow, '.rc-purchase-option__subscription')) {
          const hasOtp = !!otpEl;
          elements.otpCard.style.display = hasOtp ? '' : 'none';

          if (!hasOtp) {
            const radioOuter = elements.subCard.querySelector('.custom-radio-outer');
            if (radioOuter) radioOuter.style.display = 'none';
            elements.subCard.style.cursor = 'default';
            elements.subCard.style.width = '100%';
            elements.subCard.style.maxWidth = '100%';
            const proxy = document.getElementById('custom-recharge-proxy');
            if (proxy) {
              proxy.style.width = '100%';
              proxy.style.maxWidth = '100%';
            }
          }
          otpVisibilitySet = true;
        }
      }

      let discountPct = 0;
      const badgeEl = findDeep(shadow, '.rc-purchase-option__badge') || findDeep(shadow, '[part*="badge"]');
      if (badgeEl) {
        const badgeText = getText(badgeEl);
        if (badgeText) {
          const match = badgeText.match(/(\d+(\.\d+)?)\s*%/);
          if (match) discountPct = parseFloat(match[1]);
        }
      }

      if (!badgeVisibilitySet && otpVisibilitySet) {
        if (discountPct > 0) {
          elements.badge.innerText = getText(badgeEl);
          elements.badge.style.display = '';
        } else {
          elements.badge.style.display = 'none';
        }
        badgeVisibilitySet = true;
      }

      if (elements.subCard.classList.contains('selected')) {
        ensureSubscriptionSelected();
      }
      syncBenefitsList();

      const subPriceOldEl = findDeep(shadow, '.rc-purchase-option__subscription .rc-price.strike-through')
        || findDeep(shadow, '[part*="original-price"]');

      if (!pricesSet) {
        if (subPriceOldEl && discountPct > 0) {
          const oldPriceNum = parsePriceAmount(getText(subPriceOldEl));

          if (oldPriceNum != null) {
            const newPriceNum = oldPriceNum * (1 - discountPct / 100);
            elements.subOldPrice.innerText = formatPriceAmount(oldPriceNum);
            elements.subNewPrice.innerText = formatPriceAmount(newPriceNum);
            if (elements.otpCard.style.display !== 'none') {
              elements.otpPrice.innerText = formatPriceAmount(oldPriceNum);
            }
            pricesSet = true;
            if (!pricesSetAt) pricesSetAt = Date.now();
            hideRealWidget();
            tryMarkProxyReady();
          }
        } else {
          const subPriceEl = findDeep(shadow, '.rc-purchase-option__subscription .rc-price:not(.strike-through)')
            || findDeep(shadow, '[part*="discounted-price"]')
            || findDeep(shadow, '.rc-purchase-option__subscription .rc-price');

          if (subPriceEl) {
            const priceNum = parsePriceAmount(getText(subPriceEl));

            if (priceNum != null) {
              elements.subOldPrice.innerText = '';
              elements.subNewPrice.innerText = formatPriceAmount(priceNum);
              if (elements.otpCard.style.display !== 'none') {
                elements.otpPrice.innerText = formatPriceAmount(priceNum);
              }
              pricesSet = true;
              if (!pricesSetAt) pricesSetAt = Date.now();
              hideRealWidget();
              tryMarkProxyReady();
            }
          }
        }
      }

      const otpTitleEl = findDeep(shadow, '.rc-selection__onetime .rc-purchase-option__text');
      if (otpTitleEl) elements.otpTitle.innerText = otpTitleEl.childNodes[0].textContent.trim();

      syncFrequencySelect(findDeep(shadow, 'select'));
      tryMarkProxyReady();
    };

    const syncInterval = setInterval(syncContent, 500);

    const onSubCardClick = (e) => {
      if (e.target.tagName === 'SELECT') return;
      if (elements.otpCard.style.display === 'none') return;
      elements.subCard.classList.add('selected');
      elements.otpCard.classList.remove('selected');

      const target = findDeep(shadow, 'input[value="subscription"]')
        || findDeep(shadow, '.rc-purchase-option__subscription');
      clickRealElement(realWidget, target);
    };

    const onOtpCardClick = () => {
      elements.subCard.classList.remove('selected');
      elements.otpCard.classList.add('selected');

      const target = findDeep(shadow, 'input[value="onetime"]')
        || findDeep(shadow, '.rc-selection__onetime');
      clickRealElement(realWidget, target);
    };

    elements.subCard.addEventListener('click', onSubCardClick);
    elements.otpCard.addEventListener('click', onOtpCardClick);

    activeController = {
      resetVariantState() {
        lastVariant = '';
        resetOnVariantChange();
        notifyRechargeVariantChange();
      },
      destroy() {
        clearInterval(syncInterval);
        elements.subCard.removeEventListener('click', onSubCardClick);
        elements.otpCard.removeEventListener('click', onOtpCardClick);
        realWidget.style.cssText = '';
      }
    };

    return true;
  }

  function watchForRechargeWidget() {
    const widget = document.querySelector('recharge-subscription-widget') || document.querySelector('rc-widget');
    if (!widget) return false;

    if (!widget.shadowRoot) return false;

    if (!document.getElementById('custom-recharge-proxy')) {
      widget.style.opacity = '0';
      widget.style.pointerEvents = 'none';
      initProxyWidget();
    }

    return !!document.getElementById('custom-recharge-proxy');
  }

  function startWidgetWatch() {
    if (widgetWatchInterval) clearInterval(widgetWatchInterval);

    let attempts = 0;
    widgetWatchInterval = setInterval(() => {
      if (watchForRechargeWidget() || ++attempts > 50) {
        clearInterval(widgetWatchInterval);
        widgetWatchInterval = null;
      }
    }, 200);
  }

  window.ffm_reinitializeRechargeProxy = function() {
    destroyProxyWidget();
    startWidgetWatch();
  };

  document.addEventListener('product:content:updated', () => {
    window.ffm_reinitializeRechargeProxy();
    setTimeout(notifyRechargeVariantChange, 300);
  });

  if (typeof eventBus !== 'undefined' && typeof THEME_EVENTS !== 'undefined') {
    eventBus.subscribe(THEME_EVENTS.variantChange, () => {
      activeController?.resetVariantState?.();
      notifyRechargeVariantChange();
    });
  }

  startWidgetWatch();
})();
